import { ChangeEvent, useCallback, useState } from 'react'
import { BreadsByType, BreadType } from 'types/bread'
import { StockUnionType } from 'types/stock'

const useSelectBreadsByType = (breads: BreadType[]) => {
  const [selectedBreadsByType, setSelectedBreadsByType] = useState<BreadsByType>({
    daily: [],
    preorder: [],
    shared: [],
    delivery: [],
  })

  const selectBreadByType = useCallback(
    (event: ChangeEvent<HTMLInputElement>, type: StockUnionType) => {
      const breadId = event.target.id
      setSelectedBreadsByType((prevState) => {
        if (prevState[type].some((_bread) => _bread.bread_ref && _bread.bread_ref.id === breadId)) {
          prevState[type] = prevState[type].filter((_bread) => _bread.bread_ref && _bread.bread_ref.id !== breadId)
        } else {
          const bread = breads.find((bread) => bread.bread_ref && bread.bread_ref.id === breadId)
          if (!bread) return prevState
          prevState[type].push(bread)
        }
        return { ...prevState }
      })
    },
    [setSelectedBreadsByType, breads]
  )

  const selectAllBreadsByType = useCallback(
    (type: StockUnionType) =>
      setSelectedBreadsByType((prevState) => {
        const nextBreads = breads.reduce((prev: BreadType[], bread) => {
          // すでに選択されているパンは prev に追加しない
          if (
            prev.some((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id) ||
            prevState[type].some((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id)
          ) {
            return prev
          }
          prev.push(bread)
          return prev
        }, [])
        prevState[type] = [...prevState[type], ...nextBreads]
        return { ...prevState }
      }),
    [setSelectedBreadsByType, breads]
  )

  const unselectAllBreadsByType = useCallback(
    (type: StockUnionType) =>
      setSelectedBreadsByType((prevState) => {
        // すでに選択されているパンを prev から削除する
        prevState[type] = prevState[type].filter(
          (bread) => !breads.some((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id)
        )
        return { ...prevState }
      }),
    [setSelectedBreadsByType, breads]
  )

  return {
    selectBreadByType,
    selectedBreadsByType,
    selectAllBreadsByType,
    setSelectedBreadsByType,
    unselectAllBreadsByType,
  }
}

export default useSelectBreadsByType
